import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";
import { PreferenceService } from "../../services/preference.service";
import { NgbModal, NgbCarouselConfig } from "@ng-bootstrap/ng-bootstrap";
import Holidays from "date-holidays";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";
import { DeliveryClosureService } from "../../services/delivery-closure.service";
import {
  FormBuilder,
  FormArray,
  Validators,
  FormGroup,
  FormControl,
} from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { EmailService } from "src/app/services/email.service";

const RETAIL_USER_ADMIN =
  "G-EXT-GA-PHARMACEUTICAL_DISTRIBUTION__RETAIL_INDEPENDENT__RETAIL_INDEPENDENT_ORDERING__ADMIN";

@Component({
  selector: "app-delivery-closure-v2",
  templateUrl: "./delivery-closure-v2.component.html",
  styleUrls: ["./delivery-closure-v2.component.sass"],
})
export class DeliveryClosureV2Component implements OnInit {
  @ViewChild("monthsContent", { static: false }) widgetsContent: ElementRef;
  @ViewChild("contentConfirmation", { static: false }) contentConf: ElementRef;
  @ViewChild("contentLocations", { static: false })
  contentLocations: ElementRef;

  inputClosureDates;
  inputAddedDates;
  inputRemovedDates;
  isUserAdmin: boolean;
  addedPrefs = [];
  removedPrefs = [];
  displayPharmacyName;
  displayPharmacyId;
  hideConfirm: boolean;
  startYearCurrentClosureDates: string;
  midYearCurrentClosureDates: string;
  endYearCurrentClosureDates: string;
  totalAccountPrefClosureDates: string;
  displayArrowIconRight = true;
  displayArrowIconLeft = true;
  displayDeliveryClosuresByMonth = [];
  showMultipleEmails = false;
  showNextButton = false;
  addAdditionalEmails;
  shipTosAcctNumbers = [];
  removedDates = [];
  addedDates = [];
  currentScrollWidgetPosition: number;
  currentYearStr;
  currentYear: string;
  dateStr: string;
  currentUserEmail;
  isSelected: boolean;
  isPast: boolean;
  disableOnSubmit: boolean;
  additionalEmails;
  addingEmail = false;
  testMyYearArray = [];
  isDateSelected = false;
  hibeAddEmailBtn = true;
  countAdddedDates = 0;
  countremovedDates = 0;
  futureDateArr = [];
  myYearArray;
  newDate;
  holidayDays = [];
  days = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];
  scrollLeftCheck = 0;
  closureDates = [];
  updatedClosureDates = [];
  closureDateArray = [];
  loadedDates = [];
  showQuickSelYearLeft = true;
  showQuickSelYearRight = true;
  routeId;
  lastEditedId;
  lastEditedDate;
  formattedDate;
  monthOne = [];
  monthArray = [];
  selectedDates: string[];
  displayCurrentDisplayDates;
  monthName: string;
  updateSessionStorage;
  updateSessionStorageApiData;
  updateWithEmail;
  currentMonthSelcted = 0;

  emailsForm = this.fb.group({
    emails: this.fb.array([this.fb.control("", [Validators.email])]),
  });

  selectMPForm = new FormGroup({
    selectLocations: new FormControl(),
  });

  storeLocations;

  constructor(
    private prefService: PreferenceService,
    private modalService: NgbModal,
    config: NgbCarouselConfig,
    private route: ActivatedRoute,
    private spinnerService: Ng4LoadingSpinnerService,
    private deliveryClosureService: DeliveryClosureService,
    private fb: FormBuilder
  ) {
    config.showNavigationArrows = true;
    config.keyboard = false;
  }

  ngOnInit() {
    this.removedDates = [];
    this.addedDates = [];
    this.closureDateArray = [];

    this.getIsUserAdmin();

    this.route.params.subscribe((params) => {
      this.routeId = params["id"];
    });

    if (this.routeId === undefined) {
      sessionStorage.setItem("shiptoIndex", "0");
    } else {
      sessionStorage.setItem("shipToIndex", this.routeId);
    }

    this.currentYearStr = new Date().getFullYear();
    this.currentYear = this.currentYearStr.toString();
    this.holidayDays = this.getHolidaysByYear(this.currentYear);
    this.buildYearArrayForUi(this.currentYear);
    this.getPreferences(this.currentYear, true);
    //this.buildYearArrayForUi(this.currentYear)

    this.deliveryClosureService.$selectedPharmacy.subscribe((data) => {
      sessionStorage.setItem("shiptoIndex", data);
      //this.closureDates = [];
      this.getPreferences(this.currentYear, true);
      this.displayUpdatedDeliveryClosuresByMonth();
      this.displayCurrentPharmacyClosures(this.displayCurrentDisplayDates);
      this.buildYearArrayForUi(this.currentYear);

      this.currentUserEmail = this.getUserEmailFromSessionStorage();
      this.removedDates = [];
      this.addedDates = [];
      this.closureDateArray = [];
    });

    //this.setDelay(this.getPreferences("2020", true))
    this.displayUpdatedDeliveryClosuresByMonth();
    this.getToolTipPastToday();
    this.selectedDates = new Array<string>();
    this.currentUserEmail = this.getUserEmailFromSessionStorage();
    this.displayCurrentPharmacyClosures(this.displayCurrentDisplayDates);

    this.storeLocations = JSON.parse(sessionStorage.getItem("userAPIData"));
    this.createPharmacyStores(this.storeLocations);
  }

  createPharmacyStores(storeAccountNumbers) {
    for (let i = 0; i < storeAccountNumbers.shipTos.length; i++) {
      this.shipTosAcctNumbers.push(storeAccountNumbers.shipTos[i].id);
    }
  }

  onSelctLocations(event) {
    this.showNextButton = true;
  }

  get emails() {
    return this.emailsForm.get("emails") as FormArray;
  }

  updateClosureDates(emails) {
    this.updateClosureDatePreferences(this.currentYear);
    if (emails.length !== 0) {
      this.updateClosureDatesWithEmail(this.currentYear, emails);
    }
    this.startYearCurrentClosureDates = "";
    this.midYearCurrentClosureDates = "";
    this.endYearCurrentClosureDates = "";
    this.displayUpdatedDeliveryClosuresByMonth();
  }

  public isDateClosed(dateSelected, closureDates) {
    let isClosed;
    if (closureDates.includes(dateSelected)) {
      isClosed = true;
    } else {
      isClosed = false;
    }
    return isClosed;
  }

  getUserEmailFromSessionStorage() {
    let apiData = JSON.parse(sessionStorage.getItem("userAPIData"));
    let emailString = apiData.email;

    return emailString;
  }

  private getPreferences(selectedYear, submit): any {
    this.totalAccountPrefClosureDates = "";
    this.closureDateArray = [];
    this.displayCurrentDisplayDates = [];
    this.spinnerService.show();
    let addedDatesForDisplay = [];
    let addedDates2020 = [],
      addedDates2021 = [],
      addedDates2022 = [];

    this.addedDates.forEach((addedDate) => {
      let addDateStr = addedDate.split("/");
      let addDateYear = addDateStr[2];

      switch (addDateYear) {
        case "2020":
          addedDates2020.push(addedDate);
          break;
        case "2021":
          addedDates2021.push(addedDate);
          break;
        case "2022":
          addedDates2022.push(addedDate);
      }
    });

    this.prefService.getAccountPrefs(selectedYear).subscribe(
      (data) => {
        if (data.accountPreferenceDataList.length === 0) {
          this.lastEditedId = "";

          this.displayCurrentPharmacyClosures(this.closureDateArray);
          this.buildYearArrayForUi(selectedYear);
          this.displayUpdatedDeliveryClosuresByMonth();
        } else {
          this.closureDateArray = this.getAccountPreferenceClosureDatesForPharmacyAndCAH(
            data
          );
          this.displayCurrentDisplayDates = this.getAccountPreferenceClosureDatesForPharmacyAndCAH(
            data
          );
          this.displayCurrentPharmacyClosures(this.closureDateArray);
          this.displayUpdatedDeliveryClosuresByMonth();
          this.buildYearArrayForUi(selectedYear);
          this.lastEditedId = data.accountPreferenceDataList[0].lastUpdatedBy;
          this.formattedDate = this.convertGMTtoEST(
            data.accountPreferenceDataList[0].lastUpdateTimeStamp
          );
          this.lastEditedDate = this.getParseDate(this.formattedDate);
        }
        if (this.currentMonthSelcted <= 0) {
          this.scrollRightOnStart();
        }

        // this.scrollRightOnStart();

        this.spinnerService.hide();
      },
      (error) => {
        alert("There was an error in preferences " + error);
      }
    );
  }

  updateClosureDatePreferences(currentYear) {
    this.updateSessionStorage = sessionStorage.getItem("prefApi");
    let apiData = JSON.parse(sessionStorage.getItem("userAPIData"));
    let removedDates = this.removedDates;
    let addedDates = this.addedDates;
    let currentUserId = apiData.id;
    let transId = this.generateTransactionId();
    let userId = currentUserId;
    let preferenceId = this.totalAccountPrefClosureDates;
    let shipToIndex = sessionStorage.getItem("shiptoIndex");

    this.displayPharmacyName = apiData.shipTos[shipToIndex].name;
    this.displayPharmacyId = apiData.shipTos[shipToIndex].id;
    let key = apiData.shipTos[shipToIndex].id;
    this.prefService
      .updateAccountPrefs(
        transId,
        userId,
        preferenceId,
        key,
        currentYear,
        removedDates,
        addedDates
      )
      .subscribe((response) => {
        this.totalAccountPrefClosureDates = "";
        this.closureDateArray = [];
        this.displayCurrentDisplayDates = [];
        this.getPreferences(this.currentYear, true);
        //this.displayCurrentPharmacyClosures(this.closureDateArray);
        //this.displayUpdatedDeliveryClosuresByMonth();
        //this.buildYearArrayForUi(this.currentYear);
      });
  }

  updateClosureDatesWithEmail(currentYear, addEmail) {
    this.updateSessionStorage = sessionStorage.getItem("prefApi");
    let apiData = JSON.parse(sessionStorage.getItem("userAPIData"));
    let currentUserId = apiData.id;
    let transId = this.generateTransactionId();
    let userId = currentUserId;
    this.addedPrefs = this.addedDates;
    this.removedPrefs = this.removedDates;
    let shiptoIndex = sessionStorage.getItem("shipToIndex");

    if (shiptoIndex === null) {
      shiptoIndex = "0";
    }
    let key = this.displayPharmacyId;
    let keyName = this.displayPharmacyName;
    let firstName = apiData.firstName;
    let email = addEmail;

    this.prefService
      .sendEmailUpdateAccountPrefs(
        transId,
        userId,
        this.addedDates,
        this.removedDates,
        key,
        currentYear,
        keyName,
        firstName,
        email
      )
      .subscribe((response) => {
        // this.addedDates = [];
        // this.removedDates = [];
      });
  }
  getAccountPreferenceClosureDatesForPharmacyAndCAH(closureDateListFromApi) {
    let combinedDates = [];
    if (closureDateListFromApi.accountPreferenceDataList.length > 0) {
      let splitStrOne = closureDateListFromApi.accountPreferenceDataList[0].preference.split(
        ","
      );
      splitStrOne.forEach((date) => {
        combinedDates.push(date);
      });
      return combinedDates.sort();
    }
    this.displayUpdatedDeliveryClosuresByMonth();
    return combinedDates;
  }

  getOrderedCloseureDates(closureDates) {
    let parsedDatesArray = JSON.stringify(closureDates);
    let strArray = parsedDatesArray.split(",");
    return strArray.sort();
  }

  scrollLeft() {
    this.widgetsContent.nativeElement.scrollLeft -= 369;

    if (
      this.widgetsContent.nativeElement.scrollLeft === 0 &&
      this.currentYear === "2022"
    ) {
      if (this.scrollLeftCheck >= 2) {
        this.displayArrowIconLeft = true;
        this.displayArrowIconRight = true;
        this.getYear("2022");
        this.currentYear = "2022";
        this.buildYearArrayForUi("2022");
        //this.widgetsContent.nativeElement.scrollLeft = 1;
        this.scrollLeftCheck = 0;
      } else {
        this.displayArrowIconLeft = true;
        this.displayArrowIconRight = true;
        this.getYear("2021");
        this.currentYear = "2021";
        this.buildYearArrayForUi("2021");
        this.widgetsContent.nativeElement.scrollLeft = 3330;
        //this.scrollLeftCheck = 0;
      }
    } else if (
      this.widgetsContent.nativeElement.scrollLeft === 0 &&
      this.currentYear === "2021"
    ) {
      if (this.scrollLeftCheck >= 2) {
        this.displayArrowIconLeft = true;
        this.displayArrowIconRight = true;
        this.getYear("2021");
        this.currentYear = "2021";
        this.buildYearArrayForUi("2021");
        //this.widgetsContent.nativeElement.scrollLeft = 1;
        this.scrollLeftCheck = 0;
      } else {
        this.displayArrowIconLeft = true;
        this.displayArrowIconRight = true;
        this.getYear("2020");
        this.currentYear = "2020";
        this.buildYearArrayForUi("2020");
        this.widgetsContent.nativeElement.scrollLeft = 3330;
        //this.scrollLeftCheck = 0;
      }
    } else if (
      this.widgetsContent.nativeElement.scrollLeft === 0 &&
      this.currentYear === "2020"
    ) {
      this.displayArrowIconLeft = false;
      this.displayArrowIconRight = true;
    } else {
      this.displayArrowIconLeft = true;
    }
  }

  scrollRight() {
    this.scrollLeftCheck = this.scrollLeftCheck + 1;

    this.widgetsContent.nativeElement.scrollLeft += 369;
    this.displayArrowIconLeft = true;

    if (
      (this.widgetsContent.nativeElement.scrollLeft === 3330 &&
        this.currentYear === "2020") ||
      (this.widgetsContent.nativeElement.scrollLeft === 4070 &&
        this.currentYear === "2020")
    ) {
      this.displayArrowIconRight = true;
      this.displayArrowIconLeft = true;
      this.getYear("2021");
      this.currentYear = "2021";
      this.buildYearArrayForUi("2021");
      this.widgetsContent.nativeElement.scrollLeft = 0;
    } else if (
      (this.widgetsContent.nativeElement.scrollLeft === 3330 &&
        this.currentYear === "2021") ||
      (this.widgetsContent.nativeElement.scrollLeft === 4070 &&
        this.currentYear === "2021")
    ) {
      this.displayArrowIconRight = true;
      this.displayArrowIconLeft = true;
      this.getYear("2022");
      this.currentYear = "2022";
      this.buildYearArrayForUi("2022");
      this.widgetsContent.nativeElement.scrollLeft = 0;
    } else if (
      this.widgetsContent.nativeElement.scrollLeft === 3330 &&
      this.currentYear === "2022"
    ) {
      this.displayArrowIconRight = false;
      this.displayArrowIconLeft = true;
    } else {
      this.displayArrowIconLeft = true;
    }
  }

  scrollRightOnStart() {
    let currentMonth = new Date().getMonth() + 1;
    let monthSpace;

    switch (currentMonth) {
      case 1:
        monthSpace = 0;
        break;
      case 2:
        monthSpace = 370;
        break;
      case 3:
        monthSpace = 740;
        break;
      case 4:
        monthSpace = 1110;
        break;
      case 5:
        monthSpace = 1480;
        break;
      case 6:
        monthSpace = 1850;
        break;
      case 7:
        monthSpace = 2220;
        break;
      case 8:
        monthSpace = 2590;
        break;
      case 9:
        monthSpace = 2960;
        break;
      default:
        monthSpace = 3330;
    }
    let cDate = new Date();

    if (this.currentYear === cDate.getFullYear().toString()) {
      this.widgetsContent.nativeElement.scrollLeft += monthSpace;
    } else {
      this.widgetsContent.nativeElement.scrollLeft = 0;
    }
  }

  displayUpdatedDeliveryClosuresByMonth() {
    let jan = [],
      feb = [],
      mar = [],
      apr = [],
      may = [],
      jun = [],
      jul = [],
      aug = [],
      sep = [],
      oct = [],
      nov = [],
      dec = [];
    let currentClosuresObj = this.displayCurrentPharmacyClosures(
      this.displayCurrentDisplayDates
    );
    currentClosuresObj.forEach((day) => {
      let month = day.dateKey.split("/")[0];
      switch (month) {
        case "01":
          jan.push(day);
          break;
        case "02":
          feb.push(day);
          break;
        case "03":
          mar.push(day);
          break;
        case "04":
          apr.push(day);
          break;
        case "05":
          may.push(day);
          break;
        case "06":
          jun.push(day);
          break;
        case "07":
          jul.push(day);
          break;
        case "08":
          aug.push(day);
          break;
        case "09":
          sep.push(day);
          break;
        case "10":
          oct.push(day);
          break;
        case "11":
          nov.push(day);
          break;
        case "12":
          dec.push(day);
          break;
      }
    });
    this.displayDeliveryClosuresByMonth = [
      jan,
      feb,
      mar,
      apr,
      may,
      jun,
      jul,
      aug,
      sep,
      oct,
      nov,
      dec,
    ];
    return this.displayDeliveryClosuresByMonth;
  }

  displayCurrentPharmacyClosures(updatedClosureDates) {
    let dayClosure = {};
    this.updatedClosureDates = [];

    for (let i = 0; i < updatedClosureDates.length; i++) {
      let tmpDay = updatedClosureDates[i];
      let dateStr = tmpDay.split("/");
      let month = dateStr[0];
      let dayNumStr = dateStr[1];
      let year = dateStr[2];
      let currentDateStr = month + "/" + dayNumStr + "/" + year;

      dayClosure = {
        dateKey: currentDateStr,
        dateNumber: dayNumStr,
        dayOfWeek: this.getDayOfWeek(currentDateStr),
        isSelected: this.getIsSelected(currentDateStr, this.closureDateArray),
        isPast: this.getIsPast(currentDateStr),
        isDefault: this.getIsDefault(currentDateStr),
      };
      this.updatedClosureDates.push(dayClosure);
    }
    return this.updatedClosureDates;
  }

  submitClosureDates() {
    let submittedClosureDates = JSON.stringify(this.closureDates);

    this.isDateSelected = false;
  }

  disableSubmit() {
    let submit = false;
    this.isDateSelected = false;
    this.closureDateArray = [];

    this.getPreferences(this.currentYear, true);
  }

  datesSubmitted() {
    this.modalService.dismissAll();
    this.addedDates = [];
    this.removedDates = [];
  }

  getClosureDates(content) {
    let shipToNumber;
    let apiData = JSON.parse(sessionStorage.getItem("userAPIData"));
    let userDataObject = JSON.parse(sessionStorage.getItem("userDataObject"));
    let pharmacyId =
      userDataObject.shipToDCNumber + "-" + userDataObject.shipToCustomerNumber;
    let pharmacyAccts = [];

    for (let i = 0; i < apiData.shipTos.length; i++) {
      pharmacyAccts.push(apiData.shipTos[i].id);
    }
    let currentShipToIndex = pharmacyAccts.indexOf(pharmacyId);
    let shipToIndex = sessionStorage.getItem("shiptoIndex");

    // if(shipToIndex === "0"){
    //   shipToNumber = currentShipToIndex;
    // } else {

    //   shipToNumber = parseInt(shipToIndex);
    // }

    //this.updateClosureDatesSubmitDatesBtn(this.currentYear);
    this.isDateSelected = false;
    this.displayPharmacyName = apiData.shipTos[shipToIndex].name;
    this.displayPharmacyId = apiData.shipTos[shipToIndex].id;

    let key = apiData.shipTos[shipToIndex].id;

    this.modalService.open(content);
    //this.getPreferences(this.currentYear, true);

    // this.addedDates = []
    // this.removedDates = []
  }

  nextModal() {
    let selected = this.selectMPForm.value;

    if (selected.selectLocations === "yes") {
      this.showNextButton = true;
      this.updateWithEmail = false;
      this.modalService.open(this.contentLocations);

      this.selectMPForm.reset();
      this.selectMPForm.markAsPristine();
      this.selectMPForm.markAsUntouched();
      this.updateClosureDatesSubmitDatesBtn(this.currentYear);
    } else {
      this.showNextButton = true;
      this.updateWithEmail = true;
      this.updateClosureDatesSubmitDatesBtn(this.currentYear);
      this.modalService.dismissAll();
      this.modalService.open(this.contentConf);
      this.selectMPForm.reset();
      this.selectMPForm.markAsPristine();
      this.selectMPForm.markAsUntouched();
    }
  }

  addEmail() {
    this.emails.push(this.fb.control(""));
  }

  addEmailBtn() {
    this.hibeAddEmailBtn = false;
    this.addingEmail = true;
    this.hideConfirm = true;
  }

  updateClosureDatesSubmitDatesBtn(curretnYearStr) {
    let apiData = JSON.parse(sessionStorage.getItem("userAPIData"));
    let email;
    if (apiData.email !== "chris.donovan@cardinalhealth.com") {
      email = apiData.email;
    } else {
      email = "edmccormic@gmail.com";
    }

    if (this.updateWithEmail === true) {
      this.updateClosureDates(email);
    }

    this.updateClosureDatePreferences(curretnYearStr);
    //this.updateClosureDates(email);
    this.startYearCurrentClosureDates = "";
    this.midYearCurrentClosureDates = "";
    this.endYearCurrentClosureDates = "";
    //this.getPreferences(curretnYearStr, false);
    //this.getYear(this.currentYear)

    this.showNextButton = false;
    // this.addedDates = [];
    // this.removedDates = [];
  }

  updatePharmacyClosureDates(emails) {
    let emailStr = emails.join();
    this.updateClosureDatesWithEmail(this.currentYear, emailStr);

    let submit = false;
    //this.getPreferences(this.currentYear, submit);
    //this.getYear(this.currentYear);
    this.emailsForm.reset();

    this.emailsForm = this.fb.group({
      emails: this.fb.array([], [Validators.email]),
    });

    this.emailsForm.markAsPristine();
    this.emailsForm.markAsUntouched();
    this.hideConfirm = false;
    this.addingEmail = true;
    this.modalService.dismissAll();
  }

  noEmailWithAcct(additionalEmails) {
    this.updateClosureDatesWithEmail(this.currentYear, additionalEmails);
    let submit = false;
    //this.getPreferences(this.currentYear, submit);

    this.modalService.dismissAll();
  }

  getToolTipPastToday() {
    this.futureDateArr = new Array(13);

    let today = new Date();
    let options: any = { month: "2-digit", day: "2-digit", year: "numeric" };
    let todaysDate = today.toLocaleDateString("en-US", options);

    for (let i = 0; i < this.futureDateArr.length; i++) {
      let cToday = new Date(todaysDate);
      let options1 = { month: "2-digit", day: "2-digit", year: "numeric" };
      //let formatDate = cToday.toLocaleDateString("en-US", options);
      let cDay = cToday.setDate(today.getDate() + i + 1);
      let nDay = new Date(cDay);

      this.futureDateArr[i] = nDay.toLocaleDateString("en-US", options);
    }
    return this.futureDateArr;
  }

  getTooltipText(
    isPast: boolean,
    isDefault: boolean,
    isToday: boolean,
    dateKey: string
  ) {
    let isPastTodaysDate = this.futureDateArr.includes(dateKey);
    let holidayStr = dateKey.slice(0, 5);

    let currentHolidays = this.holidayDays;

    let holiDayTextArr = [
      "New Year's Day: Cardinal Health non-delivery holiday.",
      "Memorial Day: Cardinal Health non-delivery holiday.",
      "Independence Day: Cardinal Health non-delivery holiday.",
      "Labor Day: Cardinal Health non-delivery holiday.",
      "Thanksgiving: Cardinal Health non-delivery holiday.",
      "Christmas Day: Cardinal Health non-delivery holiday.",
    ];

    var text: string = "";

    if (isToday) {
      text = "Today's date. Please select an available closure date.";
    } else if (isPast && isDefault) {
      text = "Cardinal Health weekly non-delivery day.";
    } else if (isPast && !isPastTodaysDate) {
      text = "This date has passed. Please select an available closure date.";
    } else if (isDefault) {
      switch (holidayStr) {
        case "01/01":
          text = holiDayTextArr[0];
          break;
        case currentHolidays[1].slice(0, 5):
          text = holiDayTextArr[1];
          break;
        case "07/04":
          text = holiDayTextArr[2];
          break;
        case currentHolidays[3].slice(0, 5):
          text = holiDayTextArr[3];
          break;
        case currentHolidays[4].slice(0, 5):
          text = holiDayTextArr[4];
          break;
        case "12/25":
          text = holiDayTextArr[5];
          break;
        default:
          text = "Cardinal Health weekly non-delivery day.";
      }
    } else if (isPastTodaysDate) {
      text =
        "The closure deadline has passed. Please contact Customer Service at 800.926.3161 to make changes.";
    }

    return text;
  }

  getTooltipPlacement(dayOfWeek: string, dateNumber: number) {
    var placement: string = "auto";

    if (dayOfWeek === "SUN" || dayOfWeek === "MON") {
      placement = "right";
    } else if (dayOfWeek === "SAT") {
      placement = "left";
    } else if (dateNumber <= 7) {
      placement = "bottom";
    }

    return placement;
  }

  buildYearArrayForUi(year) {
    let monthArray = new Array(12);

    monthArray[0] = this.buildMonthArrayFromyYearArray(
      this.buildMonthArray("01", year)
    );
    monthArray[1] = this.buildMonthArrayFromyYearArray(
      this.buildMonthArray("02", year)
    );
    monthArray[2] = this.buildMonthArrayFromyYearArray(
      this.buildMonthArray("03", year)
    );
    monthArray[3] = this.buildMonthArrayFromyYearArray(
      this.buildMonthArray("04", year)
    );
    monthArray[4] = this.buildMonthArrayFromyYearArray(
      this.buildMonthArray("05", year)
    );
    monthArray[5] = this.buildMonthArrayFromyYearArray(
      this.buildMonthArray("06", year)
    );
    monthArray[6] = this.buildMonthArrayFromyYearArray(
      this.buildMonthArray("07", year)
    );
    monthArray[7] = this.buildMonthArrayFromyYearArray(
      this.buildMonthArray("08", year)
    );
    monthArray[8] = this.buildMonthArrayFromyYearArray(
      this.buildMonthArray("09", year)
    );
    monthArray[9] = this.buildMonthArrayFromyYearArray(
      this.buildMonthArray("10", year)
    );
    monthArray[10] = this.buildMonthArrayFromyYearArray(
      this.buildMonthArray("11", year)
    );
    monthArray[11] = this.buildMonthArrayFromyYearArray(
      this.buildMonthArray("12", year)
    );
    this.testMyYearArray = monthArray;
    return this.testMyYearArray;
  }

  buildYearArray(currentYear) {
    let year = [];
    for (let i = 0; i < 12; i++) {
      let monthsOfYear = this.buildMonthArray((i + 1).toString(), currentYear);
      year.push(monthsOfYear);
    }
    return year;
  }

  getYear(year) {
    this.scrollLeftCheck = this.scrollLeftCheck + 2;
    this.displayArrowIconLeft = true;
    this.displayArrowIconRight = true;
    let submit = true;
    this.currentYear = year;
    if (year === "2021" || year === "2022") {
      this.currentScrollWidgetPosition = 0;
      this.widgetsContent.nativeElement.scrollLeft = 0;
    }
    // this.startYearCurrentClosureDates = ''
    // this.midYearCurrentClosureDates = ''
    // this.endYearCurrentClosureDates = ''

    // this.addedDates = [];
    // this.removedDates = [];
    // this.closureDateArray = [];
    // this.displayCurrentDisplayDates = [];
    // this.totalAccountPrefClosureDates = ''

    this.getPreferences(year, submit);

    this.holidayDays = this.getHolidaysByYear(year);

    this.buildYearArrayForUi(year);
    this.displayCurrentPharmacyClosures(this.closureDateArray);
    this.displayUpdatedDeliveryClosuresByMonth();
  }

  getCurrentClosureDates(isSelectedNow: any, dateId: string) {
    let sortedClosureDates;
    this.isDateSelected = true;
    let splitDate = dateId.split("/", 3);
    let currentYear = splitDate[2];
    if (isSelectedNow === false) {
      this.closureDateArray.push(dateId);
      this.addedDates.push(dateId);
    } else {
      this.closureDateArray = this.closureDateArray.filter((m) => m != dateId);
      this.removedDates.push(dateId);
    }

    if (this.currentYear === "2020") {
      this.startYearCurrentClosureDates = this.closureDateArray.toString();
    } else if (this.currentYear === "2021") {
      this.midYearCurrentClosureDates = this.closureDateArray.toString();
    } else if (this.currentYear === "2022") {
      this.endYearCurrentClosureDates = this.closureDateArray.toString();
    } else {
    }

    if (this.startYearCurrentClosureDates === "undefined") {
      this.totalAccountPrefClosureDates =
        this.midYearCurrentClosureDates + "," + this.endYearCurrentClosureDates;
    } else if (
      this.startYearCurrentClosureDates === "undefined" &&
      this.midYearCurrentClosureDates === "undefined"
    ) {
      this.totalAccountPrefClosureDates = this.endYearCurrentClosureDates;
    } else if (
      this.startYearCurrentClosureDates === "undefined" &&
      this.endYearCurrentClosureDates === "undefined"
    ) {
      this.totalAccountPrefClosureDates = this.midYearCurrentClosureDates;
    } else if (this.midYearCurrentClosureDates === "undefined") {
      this.totalAccountPrefClosureDates =
        this.startYearCurrentClosureDates +
        "," +
        this.endYearCurrentClosureDates;
    } else if (this.endYearCurrentClosureDates === "undefined") {
      this.totalAccountPrefClosureDates =
        this.startYearCurrentClosureDates +
        "," +
        this.midYearCurrentClosureDates;
    } else if (
      this.startYearCurrentClosureDates === "undefined" &&
      this.midYearCurrentClosureDates === "undefined" &&
      this.endYearCurrentClosureDates === "undefined"
    ) {
      this.totalAccountPrefClosureDates = "";
    } else {
      this.totalAccountPrefClosureDates =
        this.startYearCurrentClosureDates +
        "," +
        this.midYearCurrentClosureDates +
        "," +
        this.endYearCurrentClosureDates;
    }

    this.inputClosureDates = this.totalAccountPrefClosureDates;
    this.inputAddedDates = this.addedDates;
    this.inputRemovedDates = this.removedDates;

    sortedClosureDates = this.getOrderedCloseureDates(this.closureDateArray);
    this.buildYearArrayForUi(currentYear);
    //this.displayCurrentPharmacyClosures(this.closureDateArray);
    this.displayCurrentPharmacyClosures(this.displayCurrentDisplayDates);
    this.displayUpdatedDeliveryClosuresByMonth();
  }

  getDateId(isSelectedNow: any, dateId: string) {
    let sortedClosureDates;
    this.isDateSelected = true;
    let splitDate = dateId.split("/", 3);
    let currentYear = splitDate[2];
    if (isSelectedNow === false) {
      this.closureDateArray.push(dateId);
      this.addedDates.push(dateId);
    } else {
      this.removedDates.push(dateId);
      this.closureDateArray = this.closureDateArray.filter((m) => m != dateId);
    }

    if (this.currentYear === "2020") {
      this.startYearCurrentClosureDates = this.closureDateArray.toString();
    } else if (this.currentYear === "2021") {
      this.midYearCurrentClosureDates = this.closureDateArray.toString();
    } else if (this.currentYear === "2022") {
      this.endYearCurrentClosureDates = this.closureDateArray.toString();
    } else {
    }

    if (this.startYearCurrentClosureDates === "undefined") {
      this.totalAccountPrefClosureDates =
        this.midYearCurrentClosureDates + "," + this.endYearCurrentClosureDates;
    } else if (
      this.startYearCurrentClosureDates === "undefined" &&
      this.midYearCurrentClosureDates === "undefined"
    ) {
      this.totalAccountPrefClosureDates = this.endYearCurrentClosureDates;
    } else if (
      this.startYearCurrentClosureDates === "undefined" &&
      this.endYearCurrentClosureDates === "undefined"
    ) {
      this.totalAccountPrefClosureDates = this.midYearCurrentClosureDates;
    } else if (this.midYearCurrentClosureDates === "undefined") {
      this.totalAccountPrefClosureDates =
        this.startYearCurrentClosureDates +
        "," +
        this.endYearCurrentClosureDates;
    } else if (this.endYearCurrentClosureDates === "undefined") {
      this.totalAccountPrefClosureDates =
        this.startYearCurrentClosureDates +
        "," +
        this.midYearCurrentClosureDates;
    } else if (
      this.startYearCurrentClosureDates === "undefined" &&
      this.midYearCurrentClosureDates === "undefined" &&
      this.endYearCurrentClosureDates === "undefined"
    ) {
      this.totalAccountPrefClosureDates = "";
    } else {
      this.totalAccountPrefClosureDates =
        this.startYearCurrentClosureDates +
        "," +
        this.midYearCurrentClosureDates +
        "," +
        this.endYearCurrentClosureDates;
    }

    this.inputClosureDates = this.totalAccountPrefClosureDates;
    this.inputAddedDates = this.addedDates;
    this.inputRemovedDates = this.removedDates;

    sortedClosureDates = this.getOrderedCloseureDates(this.closureDateArray);

    this.buildYearArrayForUi(currentYear);
    this.displayCurrentPharmacyClosures(this.closureDateArray);
    this.displayUpdatedDeliveryClosuresByMonth();
  }

  private getIsUserAdmin() {
    let userData = JSON.parse(sessionStorage.getItem("userAPIData"));
    let memberSettings = userData.userSettings.memberGroups;

    if (memberSettings.includes(RETAIL_USER_ADMIN)) {
      this.isUserAdmin = true;
    } else {
      this.isUserAdmin = false;
    }

    return this.isUserAdmin;
  }

  buildMonthArrayFromyYearArray(arrayOfWeeks) {
    let weekOneArray = [],
      weekTwoArray = [],
      weekThreeArray = [],
      weekFourArray = [],
      weekFiveArray = [],
      weekSixArray = [];

    weekOneArray = arrayOfWeeks.splice(0, 7);
    weekTwoArray = arrayOfWeeks.splice(0, 7);
    weekThreeArray = arrayOfWeeks.splice(0, 7);
    weekFourArray = arrayOfWeeks.splice(0, 7);
    weekFiveArray = arrayOfWeeks.splice(0, 7);
    weekSixArray = arrayOfWeeks.splice(0, 7);

    this.monthArray = [
      weekOneArray,
      weekTwoArray,
      weekThreeArray,
      weekFourArray,
      weekFiveArray,
      weekSixArray,
    ];

    return this.monthArray;
  }

  buildMonthArray(monthStr, yearStr) {
    let day = {};
    let daySpare = {};
    let dayEnd = {};
    let monthArray = [];
    let month;
    let numberOfDaysInMonth = this.getDaysInaMonth(monthStr, yearStr);
    if (monthStr.length === 1) {
      month = "0" + monthStr;
    } else {
      month = monthStr;
    }
    let year = yearStr;

    for (let i = 0; i < numberOfDaysInMonth; i++) {
      let dayNumStr;
      let dateNumberStr;
      if (i + 1 < 10) {
        dayNumStr = "" + (i + 1).toString();
      } else {
        dayNumStr = (i + 1).toString();
      }

      if (dayNumStr.length < 2) {
        dateNumberStr = "0" + dayNumStr;
      } else {
        dateNumberStr = dayNumStr;
      }
      day = {
        dateKey: month + "/" + dateNumberStr + "/" + year,
        dateNumber: dayNumStr,
        dayOfWeek: this.getDayOfWeek(month + "/" + dayNumStr + "/" + year),
        isSelected: this.getIsSelected(
          month + "/" + dayNumStr + "/" + year,
          this.closureDateArray
        ),
        isPast: this.getIsPast(month + "/" + dayNumStr + "/" + year),
        isDefault: this.getIsDefault(month + "/" + dayNumStr + "/" + year),
      };
      monthArray.push(day);
    }

    if (monthArray[0].dateNumber === "1") {
      let numberOfDaysToAdd = this.getFirstDayOfWeekLength(
        monthArray[0].dayOfWeek
      );

      for (let k = 0; k < numberOfDaysToAdd; k++) {
        daySpare = {
          dateKey: "00/00/0000",
          dateNumber: "0",
          dayOfWeek: "",
          isSelected: false,
          isPast: true,
          isDefault: false,
        };
        monthArray.unshift(daySpare);
      }
    }
    if (monthArray.length > 28) {
      let finalWeekCount = this.getLastDayOfWeekLength(
        this.getDayOfWeek(month + "/" + numberOfDaysInMonth + "/" + year)
      );
      for (let i = 0; i < finalWeekCount; i++) {
        dayEnd = {
          dateKey: "00/00/0000",
          dateNumber: "0",
          dayOfWeek: "",
          isSelected: false,
          isPast: true,
          isDefault: false,
        };
        monthArray.push(dayEnd);
      }
    }
    if (monthArray.length === 35) {
      for (let i = 0; i < 7; i++) {
        dayEnd = {
          dateKey: "00/00/0000",
          dateNumber: "0",
          dayOfWeek: "",
          isSelected: false,
          isPast: true,
          isDefault: false,
        };
        monthArray.push(dayEnd);
      }
    }

    return monthArray;
  }

  getDaysInaMonth(month, year) {
    let monthNumber = parseInt(month);
    let yearNumber = parseInt(year);
    return new Date(yearNumber, monthNumber, 0).getDate();
  }

  getDayOfWeek(dateClosure) {
    let month = parseInt(dateClosure.slice(0, 2));
    let day = parseInt(dateClosure.slice(3, 5));
    let year = parseInt(dateClosure.slice(6, 10));
    let weekDay = "";
    if (month < 3) {
      month = month + 12;
      year = year - 1;
    }
    let cal = Math.floor(year / 100);
    let key = year - 100 * cal;
    let set =
      Math.floor(2.6 * month - 5.39) +
      Math.floor(key / 4) +
      Math.floor(cal / 4) +
      day +
      key -
      2 * cal;
    let ans = set - 7 * Math.floor(set / 7);
    const weekDays = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];
    weekDay = weekDays[ans];
    return weekDay;
  }

  getIsSelected(dateString, closureDates): boolean {
    let splitDate = dateString.split("/");
    let mm = splitDate[0];
    let dd;
    let yyyy = splitDate[2];
    if (splitDate[1].length < 2) {
      dd = "0" + splitDate[1];
    } else {
      dd = splitDate[1];
    }
    let newStrDate = mm + "/" + dd + "/" + yyyy;
    let isSelected = false;

    if (closureDates.includes(newStrDate)) {
      isSelected = true;
    } else {
      isSelected = false;
    }
    return isSelected;
  }

  getIsPast(dateProvided): boolean {
    let date = new Date();
    let dayIs14FromHoliday = true;
    let d = date.getDate();
    let m = date.getMonth() + 1;
    let y = date.getFullYear();
    let todayDateString =
      (m <= 9 ? "0" + m : m) + "/" + (d <= 9 ? "0" + d : d) + "/" + y;

    let pastDate = Date.now() + -14 * 24 * 3600 * 1000;
    let pastDateMinus14 = new Date(pastDate);

    let past14Date = pastDateMinus14.toLocaleDateString;
    let dPast = pastDateMinus14.getDate();
    let mPast = pastDateMinus14.getMonth() + 1;
    let yPast = pastDateMinus14.getFullYear();
    let pastDateString =
      (mPast <= 9 ? "0" + mPast : mPast) +
      "/" +
      (dPast <= 9 ? "0" + dPast : dPast) +
      "/" +
      yPast;

    this.holidayDays.forEach((element) => {
      if (element === pastDateString) {
        dayIs14FromHoliday = true;
      } else {
        dayIs14FromHoliday = false;
      }
    });
    let isPastDate = false;
    let todayDate = new Date(todayDateString);
    let todayPlus14 = new Date(todayDate.setDate(todayDate.getDate() + 14));
    let providedDate = new Date(dateProvided);
    if (todayPlus14 > providedDate || dayIs14FromHoliday) {
      //||  dateProvided === '12/31/2019'
      isPastDate = true;
    } else {
      isPastDate = false;
    }
    return isPastDate;
  }

  getIsHoliday(dateString): boolean {
    let currentYearHolidays = this.getHolidaysByYear(dateString.split("/")[2]);

    return currentYearHolidays.includes(dateString);
  }

  getIsDefault(dateString): boolean {
    this.holidayDays;

    let currentString = dateString.split("/");

    let mm = currentString[0];
    let yyyy = currentString[2];
    let dd;
    if (currentString[1].length === 1) {
      dd = "0" + currentString[1];
    } else {
      dd = currentString[1];
    }

    let compareDateStr = mm + "/" + dd + "/" + yyyy;

    let isDefault;
    this.getDayOfWeek(compareDateStr);
    if (
      this.getDayOfWeek(compareDateStr) === "SUN" ||
      this.getDayOfWeek(compareDateStr) === "SAT" ||
      this.holidayDays.includes(compareDateStr)
    ) {
      isDefault = true;
    } else {
      isDefault = false;
    }

    return isDefault;
  }

  getHolidaysByYear(year) {
    let hd = new Holidays("US");
    let holidayArray = [];
    let currentYearHolidays = [];
    let holidayStrArray = [];

    holidayArray = hd.getHolidays(year);

    holidayArray.forEach((day) => {
      let NYE = "New Year's Day";
      let MLK = "Martin Luther King Jr. Day";
      let MD = "Memorial Day";
      let ID = "Independence Day";
      let LBD = "Labor Day";
      let TH = "Thanksgiving Day";
      let CD = "Christmas Day";
      switch (day.name) {
        case NYE:
          currentYearHolidays.push(day);
          break;
        case MLK:
          currentYearHolidays.push(day);
          break;
        case MD:
          currentYearHolidays.push(day);
          break;
        case ID:
          currentYearHolidays.push(day);
          break;
        case LBD:
          currentYearHolidays.push(day);
          break;
        case TH:
          currentYearHolidays.push(day);
          break;
        case CD:
          currentYearHolidays.push(day);
      }
    });
    currentYearHolidays.forEach((day) => {
      let splitDate = day.date.split(" ")[0];
      let yearStr = splitDate.split("-")[0];
      let monthStr = splitDate.split("-")[1];
      let dayStr = splitDate.split("-")[2];
      let finalDate = monthStr + "/" + dayStr + "/" + yearStr;
      holidayStrArray.push(finalDate);
    });

    return holidayStrArray;
  }

  getFirstDayOfWeekLength(dayOfFirstWeek) {
    let numberOfDays = 0;
    switch (dayOfFirstWeek) {
      case "SUN":
        numberOfDays = 0;
        break;
      case "MON":
        numberOfDays = 1;
        break;
      case "TUE":
        numberOfDays = 2;
        break;
      case "WED":
        numberOfDays = 3;
        break;
      case "THU":
        numberOfDays = 4;
        break;
      case "FRI":
        numberOfDays = 5;
        break;
      default:
        numberOfDays = 6;
    }
    return numberOfDays;
  }

  getLastDayOfWeekLength(dayOflastWeek) {
    let numberOfDays = 0;
    switch (dayOflastWeek) {
      case "SUN":
        numberOfDays = 6;
        break;
      case "MON":
        numberOfDays = 5;
        break;
      case "TUE":
        numberOfDays = 4;
        break;
      case "WED":
        numberOfDays = 3;
        break;
      case "THU":
        numberOfDays = 2;
        break;
      case "FRI":
        numberOfDays = 1;
        break;
      default:
        numberOfDays = 0;
    }
    return numberOfDays;
  }

  public convertGMTtoEST(lastEditedDate) {
    let date, estDate, tmpDate, convertedDate;
    date = new Date(lastEditedDate);
    estDate = date.setHours(date.getHours() - 4);
    tmpDate = new Date(estDate);
    let mm = tmpDate.getMonth() + 1;
    let dd = tmpDate.getDate();
    let yy = tmpDate.getFullYear();

    if (mm.toString().length === 1) {
      mm = "0" + mm;
    }

    if (dd.toString().length === 1) {
      dd = "0" + dd;
    }

    convertedDate = mm + "/" + dd + "/" + yy;

    return convertedDate;
  }

  public getParseDate(lastEditedDate) {
    let formattedDate = "";
    let month = this.getMonth(lastEditedDate.slice(0, 2));
    let day = lastEditedDate.slice(3, 5);

    let year = lastEditedDate.slice(6, 10);

    formattedDate = month + " " + day + ", " + year;
    return formattedDate;
  }

  public getMonth(month) {
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "July",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    let monthName = monthNames[parseInt(month) - 1];
    return monthName;
  }

  public generateTransactionId() {
    let transactionId =
      "account-" +
      Math.random().toString(36).substring(2, 15) +
      Math.random().toString(36).substring(2, 15);

    return transactionId;
  }
}
